const { id, log } = require("../std/index")


//
// Gallery Controls
//
// Remotely control fadeshow galleries (casings diagram bg and apparel images)
//

module.exports = class GalleryControls {
  constructor($host, config) {
    this.activeClass = 'is-active';

    this.dom = {
      main: $host,
      buttons: $('[data-slide-ix]', $host)
    };

    this.callbacks = [];

    this.dom.buttons.on('click', ({ target }) => {
      const ix = $(target).data('slide-ix');
      this.callbacks.map(callback => callback(ix));
    });
  }

  onSelect(λ) {
    this.callbacks.push(λ);
  }

  setActive(ix) {
    this.dom.buttons.removeClass(this.activeClass).eq(ix).addClass(this.activeClass);
  }
};
